const HOME = "home";
const CANDIDATES = "candidates";
const OFFICIAL_PROFILE = "officialProfile";
const CANDIDATE_PROFILE = "candidateProfile";
const ELECTED_OFFICIALS = "electedOfficials";
const REGISTER_TO_VOTE = "registerToVote";
const VOTER_INFORMATION = "voterInformation";

export default {
  HOME,
  CANDIDATES,
  OFFICIAL_PROFILE,
  CANDIDATE_PROFILE,
  ELECTED_OFFICIALS,
  REGISTER_TO_VOTE,
  VOTER_INFORMATION
};
